import React from 'react'
import { Link } from 'react-router-dom';

const CoirMattress = () => {
    return (
        <>
            <div class="product-section">
                <div class="container">
                    <div class="row">

                        {/* <!-- Start Column 2 --> */}
                        {/* <div class="col-12 col-md-4 col-lg-3 mb-5 mb-md-0">
                            <Link class="product-item" to="cart.html">
                                <img src="/images/foam5.jpg" class="img-fluid product-thumbnail" />
                                <h3 class="product-title">ComfortLux Spring Mattress</h3>
                                <strong class="product-price">₹ 10500</strong>

                                <span class="icon-cross">
                                    <img src="images/cross.svg" class="img-fluid" />
                                </span>
                            </Link>
                        </div> */}
                        {/* <!-- End Column 2 --> */}

                        {/* <!-- Start Column 3 --> */}
                        {/* <div class="col-12 col-md-4 col-lg-3 mb-5 mb-md-0">
                            <Link class="product-item" to="cart.html">
                                <img src="/images/coir5.jpg" />
                                <h3 class="product-title mt-5">AirFeel Foam Mattress</h3>
                                <strong class="product-price">₹ 7800</strong>

                                <span class="icon-cross">
                                    <img src="images/cross.svg" class="img-fluid" />
                                </span>
                            </Link>
                        </div> */}
                        {/* <!-- End Column 3 --> */}

                        {/* <!-- Start Column 4 --> */}
                        {/* <div class="col-12 col-md-4 col-lg-3 mb-5 mb-md-0">
                            <Link class="product-item" to="cart.html">
                                <img src="/images/mattress1.jfif" />
                                <h3 class="product-title">OrthoCoir Mattress</h3>
                                <strong class="product-price">₹ 14430</strong>

                                <span class="icon-cross">
                                    <img src="images/cross.svg" class="img-fluid" />
                                </span>
                            </Link>
                        </div> */}
                        {/* <!-- End Column 4 --> */}

                        {/* <!-- Start Column 5 --> */}
                        <div class="col-12 col-md-4 col-lg-3 mb-5 mb-md-0">
                            <Link class="product-item" to="cart.html">
                                <img src="/images/mattress4.webp" class="img-fluid product-thumbnail" />
                                <h3 class="product-title">OrthoCoir Mattress</h3>
                                <strong class="product-price">₹ 14430</strong>

                                <span class="icon-cross">
                                    <img src="images/cross.svg" class="img-fluid" />
                                </span>
                            </Link>
                        </div>
                        {/* <!-- End Column 5 --> */}

                        {/* <!-- Start Column 6 --> */}
                        <div class="col-12 col-md-4 col-lg-3 mb-5 mb-md-0 mt-4">
                            <Link class="product-item" to="cart.html">
                                <img src="/images/spring4.jpg" class="img-fluid product-thumbnail" />
                                <h3 class="product-title">OrthoCoir Mattress</h3>
                                <strong class="product-price">₹ 14430</strong>

                                <span class="icon-cross">
                                    <img src="images/cross.svg" class="img-fluid" />
                                </span>
                            </Link>
                        </div>
                        {/* <!-- End Column 6 --> */}

                        {/* <!-- Start Column 7 --> */}
                        <div class="col-12 col-md-4 col-lg-3 mb-5 mb-md-0 mt-4">
                            <Link class="product-item" to="cart.html">
                                <img src="/images/mattress5.webp" class="img-fluid product-thumbnail" />
                                <h3 class="product-title">OrthoCoir Mattress</h3>
                                <strong class="product-price">₹ 14430</strong>

                                <span class="icon-cross">
                                    <img src="images/cross.svg" class="img-fluid" />
                                </span>
                            </Link>
                        </div>
                        {/* <!-- End Column 7 --> */}

                        {/* <!-- Start Column 8 --> */}
                        <div class="col-12 col-md-4 col-lg-3 mb-5 mb-md-0 mt-4">
                            <Link class="product-item" to="cart.html">
                                <img src="/images/mattress7.webp" class="img-fluid product-thumbnail" />
                                <h3 class="product-title">OrthoCoir Mattress</h3>
                                <strong class="product-price">₹ 14430</strong>

                                <span class="icon-cross">
                                    <img src="images/cross.svg" class="img-fluid" />
                                </span>
                            </Link>
                        </div>
                        {/* <!-- End Column 8 --> */}

                        {/* <!-- Start Column 9 --> */}
                        {/* <div class="col-12 col-md-4 col-lg-3 mb-5 mb-md-0 mt-4">
                            <Link class="product-item" to="cart.html">
                                <img src="/images/coir5.jpg" class="img-fluid product-thumbnail" />
                                <h3 class="product-title">OrthoCoir Mattress</h3>
                                <strong class="product-price">₹ 14430</strong>

                                <span class="icon-cross">
                                    <img src="images/cross.svg" class="img-fluid" />
                                </span>
                            </Link>
                        </div> */}
                        {/* <!-- End Column 9 --> */}

                    </div>
                </div>
            </div>
        </>
    )
}

export default CoirMattress;